import { ARTISTS } from "@/lib/brand";

export const Artists = () => {
  // duplicate for seamless marquee loop
  const row = [...ARTISTS, ...ARTISTS];

  return (
    <section
      id="artists"
      data-testid="artists-section"
      className="relative py-24 lg:py-32 border-y border-white/10 overflow-hidden"
    >
      {/* Faded band photo background — ombre fade to hide watermark on bottom */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="/assets/band.jpg"
          srcSet="/assets/band-sm.jpg 800w, /assets/band.jpg 1600w"
          sizes="100vw"
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover object-center opacity-60"
        />
        {/* light wash to keep text legible */}
        <div className="absolute inset-0 bg-black/45" />
        {/* strong ombre fade from top (visible) → bottom (solid black to hide watermark) */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
        <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-black to-transparent" />
        <div className="absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-black to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between gap-10 flex-wrap mb-12 lg:mb-16">
          <div>
            <p
              data-testid="artists-eyebrow"
              className="font-body text-xs uppercase tracking-[0.3em] text-white/80"
            >
              [ Credits ]
            </p>
            <h2
              data-testid="artists-headline"
              className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white"
            >
              Names on the{" "}
              <span className="text-eq-gradient">Marquee</span>.
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="font-body text-sm lg:text-base text-white/80 leading-relaxed">
              Gospel, and Worship artists CJ has Produced, Arranged,
              Engineered or Music Directed for.
            </p>
          </div>
        </div>
      </div>

      {/* Marquee strip — single row, light weight, smaller text, dot separators */}
      <div data-testid="artists-marquee" className="relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

        <div className="flex items-center gap-10 lg:gap-14 marquee-track whitespace-nowrap py-2">
          {row.map((name, i) => (
            <span
              key={`${name}-${i}`}
              data-testid={`artist-name-${i}`}
              className="flex items-center gap-10 lg:gap-14 font-display font-light text-xl lg:text-2xl tracking-tight text-white/90 hover:text-white transition-colors"
            >
              {name}
              <span
                aria-hidden="true"
                className="inline-block h-1.5 w-1.5 lg:h-2 lg:w-2 rounded-full bg-white/40"
              />
            </span>
          ))}
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 mt-12 lg:mt-16">
        <p className="font-body text-xs uppercase tracking-[0.3em] text-white/70">
          {ARTISTS.length}+ Featured Credits · And Many More
        </p>
      </div>
    </section>
  );
};
